import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import Input from '../../common/Input';
import { getCities } from '../../../utils/functions';

const License = ({
  formData,
  invalidFields,
  handleChange,
  handleBlur,

  isItalia,
  isDriver,
  nations
}) => {
  const { t } = useTranslation();

  const handleIssuedByChange = (field, value, callback) => {
    handleChange(field, value);
    if (!isItalia) return;
    getCities(value).then(res => callback(res));
  };

  const handleIssuedBySelect = (option) => {
    handleChange('licenseIssuedBy', option.comune);
  };

  return <div className='customer__form__data data--license'>
    {['sole-proprietorship'].includes(formData.type) && <Input
      type='toggle'
      name='isDriver'
      label={t('customer.form.isDriver.label')}
      value={formData.isDriver || false}
      onChange={handleChange}
      onBlur={handleBlur}
    />}
    {isDriver && (<>
      <Input
        type='text'
        name='licenseNumber'
        label={t('customer.form.licenseNumber.label')}
        value={formData.licenseNumber || ''}
        invalid={invalidFields['licenseNumber']}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        type='text'
        name='licenseCategory'
        label={t('customer.form.licenseCategory.label')}
        value={formData.licenseCategory || ''}
        invalid={invalidFields['licenseCategory']}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        type={isItalia ? 'autocomplete' : 'select'}
        name='licenseIssuedBy'
        label={t('customer.form.licenseIssuedBy.label')}
        helper={isItalia ? t('customer.form.licenseIssuedBy.cityHelper') : t('customer.form.licenseIssuedBy.nationHelper')}
        value={formData.licenseIssuedBy || ''}
        invalid={invalidFields['licenseIssuedBy']}
        options={['', ...nations]}
        onChange={handleIssuedByChange}
        onSelect={handleIssuedBySelect}
        onBlur={handleBlur}
      />
      <Input
        type='date'
        name='licenseReleaseDate'
        label={t('customer.form.licenseReleaseDate.label')}
        value={formData.licenseReleaseDate}
        invalid={invalidFields['licenseReleaseDate']}
        datePickerMax={dayjs().toDate()}
        onChange={handleChange}
      />
      <Input
        type='date'
        name='licenseExpirationDate'
        label={t('customer.form.licenseExpirationDate.label')}
        value={formData.licenseExpirationDate}
        invalid={invalidFields['licenseExpirationDate']}
        datePickerMin={dayjs().toDate()}
        onChange={handleChange}
      />
    </>)}
  </div>;
};

export default License;
